import { render, staticRenderFns } from "./AuthorisationCodeRevokeTokens.vue?vue&type=template&id=7818a0fb&scoped=true"
import script from "./AuthorisationCodeRevokeTokens.vue?vue&type=script&lang=js"
export * from "./AuthorisationCodeRevokeTokens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7818a0fb",
  null
  
)

export default component.exports